(() => {
  const article = document.querySelector("[data-journal-article]");
  if (!article) return;

  const body = article.querySelector("[data-journal-body]");
  const toc = article.querySelector("[data-journal-toc]");
  const tocList = article.querySelector("[data-journal-toc-list]");
  const progress = article.querySelector("[data-journal-progress]");

  if (!body) return;

  const enhanceFaq = () => {
    const faqHeading = [...body.querySelectorAll("h2")].find((heading) =>
      /^(faqs?|frequently asked questions)$/i.test(heading.textContent.trim()),
    );
    if (!faqHeading) return;

    const items = [];
    let cursor = faqHeading.nextSibling;

    while (cursor) {
      if (cursor.nodeType === Node.ELEMENT_NODE && cursor.matches("h2")) break;

      if (cursor.nodeType === Node.ELEMENT_NODE && cursor.matches("h3")) {
        const question = cursor;
        const answerNodes = [];
        cursor = cursor.nextSibling;

        while (cursor) {
          if (cursor.nodeType === Node.ELEMENT_NODE && cursor.matches("h2, h3")) break;
          const next = cursor.nextSibling;
          answerNodes.push(cursor);
          cursor = next;
        }

        items.push({ question, answerNodes });
        continue;
      }

      cursor = cursor.nextSibling;
    }

    if (items.length < 2) return;

    const section = document.createElement("section");
    section.className = "journal-faq";
    const list = document.createElement("div");
    list.className = "journal-faq__list";

    faqHeading.before(section);
    faqHeading.classList.add("journal-faq__heading");
    section.append(faqHeading, list);

    items.forEach(({ question, answerNodes }, index) => {
      const details = document.createElement("details");
      details.className = "journal-faq__item";
      if (index === 0) details.open = true;

      const summary = document.createElement("summary");
      summary.className = "journal-faq__question";

      const questionText = document.createElement("span");
      questionText.className = "journal-faq__question-text";
      questionText.textContent = question.textContent.trim().replace(/\s+/g, " ");

      const indicator = document.createElement("span");
      indicator.className = "journal-faq__indicator";
      indicator.setAttribute("aria-hidden", "true");

      const answer = document.createElement("div");
      answer.className = "journal-faq__answer";
      answerNodes.forEach((node) => answer.append(node));

      summary.append(questionText, indicator);
      details.append(summary, answer);
      list.append(details);
      question.remove();
    });
  };

  enhanceFaq();

  const headings = [...body.querySelectorAll("h2")];
  const usedIds = new Set([...document.querySelectorAll("[id]")].map((node) => node.id));

  const makeId = (text, index) => {
    const base = text
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || `section-${index + 1}`;
    let id = base;
    let suffix = 2;
    while (usedIds.has(id)) {
      id = `${base}-${suffix}`;
      suffix += 1;
    }
    usedIds.add(id);
    return id;
  };

  if (toc && tocList && headings.length >= 3) {
    const fragment = document.createDocumentFragment();

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = makeId(heading.textContent.trim(), index);

      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      fragment.append(item);
    });

    tocList.append(fragment);
    toc.hidden = false;

    if ("IntersectionObserver" in window) {
      const links = new Map(
        [...tocList.querySelectorAll("a")].map((link) => [link.getAttribute("href").slice(1), link]),
      );
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (!visible) return;
          links.forEach((link, id) => {
            if (id === visible.target.id) link.setAttribute("aria-current", "location");
            else link.removeAttribute("aria-current");
          });
        },
        { rootMargin: "-18% 0px -70%", threshold: 0 },
      );
      headings.forEach((heading) => observer.observe(heading));
    }
  }

  if (progress) {
    let frame = 0;
    const updateArticle = () => {
      frame = 0;

      if (progress) {
        const start = article.offsetTop;
        const distance = Math.max(article.offsetHeight - window.innerHeight, 1);
        const value = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
        progress.style.width = `${value * 100}%`;
      }

    };
    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(updateArticle);
    };
    updateArticle();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate, { passive: true });
  }
})();
